// Predictive Search - direct binding with watchdog
(function() {
  var DROPDOWN = 'predictive-search-dropdown';
  var timer = null;
  var currentXHR = null;
  var boundInputs = new WeakSet();

  function formatMoney(price) {
    var n = parseFloat(price);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function getDropdown(input) {
    var wrap = input.closest('.search-info') || input.parentElement;
    var dd = wrap.querySelector('.' + DROPDOWN);
    if (dd) return dd;
    dd = document.createElement('div');
    dd.className = DROPDOWN;
    dd.style.display = 'none';
    wrap.style.position = 'relative';
    wrap.appendChild(dd);
    return dd;
  }

  function hideAll() {
    var dds = document.querySelectorAll('.' + DROPDOWN);
    for (var i = 0; i < dds.length; i++) dds[i].style.display = 'none';
  }

  function doSearch(query, dd) {
    if (!query || query.length < 2) { dd.style.display = 'none'; return; }

    // Cancel any pending request
    if (currentXHR) { try { currentXHR.abort(); } catch(e) {} }

    var x = new XMLHttpRequest();
    currentXHR = x;
    x.open('GET', '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide');
    x.onreadystatechange = function() {
      if (x.readyState !== 4 || x !== currentXHR) return;
      if (x.status === 200) {
        try {
          var data = JSON.parse(x.responseText);
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            dd.innerHTML = '<div class="predictive-search__no-results">No products found</div>';
            dd.style.display = 'block';
            return;
          }
          var h = '';
          for (var i = 0; i < products.length; i++) {
            var p = products[i];
            var img = p.image || '';
            if (img) img = img.replace(/(\.[^.]+)$/, '_100x$1');
            var price = p.price ? formatMoney(p.price) : (p.price_min ? formatMoney(p.price_min) : '');
            var cmp = (p.compare_at_price_max && parseFloat(p.compare_at_price_max) > 0) ? formatMoney(p.compare_at_price_max) : '';
            var sale = cmp && cmp !== price;
            h += '<a href="' + p.url + '" class="predictive-search__item">';
            if (img) h += '<div class="predictive-search__image"><img loading="lazy" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '"></div>';
            h += '<div class="predictive-search__info"><div class="predictive-search__title">' + p.title + '</div><div class="predictive-search__price">';
            if (sale) h += '<span class="predictive-search__price--sale">' + price + '</span> <span class="predictive-search__price--compare">' + cmp + '</span>';
            else if (price) h += price;
            h += '</div></div></a>';
          }
          h += '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="predictive-search__view-all">View all results</a>';
          dd.innerHTML = h;
          dd.style.display = 'block';
        } catch(e) {}
      }
    };
    x.send();
  }

  function handleTyping(e) {
    var input = e.target || e.srcElement;
    var dd = getDropdown(input);
    var query = input.value.trim();
    clearTimeout(timer);
    timer = setTimeout(function() { doSearch(query, dd); }, 100);
  }

  function handleFocus(e) {
    var input = e.target || e.srcElement;
    var dd = getDropdown(input);
    if (input.value.trim().length >= 2 && dd.innerHTML) dd.style.display = 'block';
  }

  function bindInput(input) {
    if (boundInputs.has(input)) return;
    boundInputs.add(input);
    input.addEventListener('input', handleTyping, false);
    input.addEventListener('focus', handleFocus, false);
  }

  function scanAndBind() {
    var inputs = document.querySelectorAll('input[name="q"].search-header__input, input[name="q"].search-bar__input');
    for (var i = 0; i < inputs.length; i++) bindInput(inputs[i]);
  }

  // Close on outside click
  document.addEventListener('mousedown', function(e) {
    var t = e.target;
    while (t) {
      if (t.classList && (t.classList.contains(DROPDOWN) || t.classList.contains('search-header__input') || t.classList.contains('search-bar__input'))) return;
      t = t.parentElement;
    }
    hideAll();
  }, false);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) hideAll();
  }, false);

  // Bind now, on DOMContentLoaded, on load, and periodically
  scanAndBind();
  document.addEventListener('DOMContentLoaded', scanAndBind, false);
  window.addEventListener('load', scanAndBind, false);
  setInterval(scanAndBind, 500);
})();
